import { IconBaseProps } from 'react-icons';
import { PiPlus } from 'react-icons/pi';

interface ITableRowItemAddButtonProps extends IconBaseProps {
  position?: 'top' | 'bottom';
  disable?: boolean;
}

const TableRowItemAddButton = ({
  className = '',
  position = 'top',
  disable = false,
  onClick,
  ...props
}: ITableRowItemAddButtonProps) => {
  return (
    <PiPlus
      {...props}
      onClick={disable ? undefined : onClick}
      className={`add-button ${position}${
        disable ? ' disable' : ''
      } ${className}`}
    />
  );
};

export default TableRowItemAddButton;
